/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import 'ant-design-vue/dist/antd.css';
import "mavon-editor/dist/css/index.css";
import './middleware'
import './scss/app.scss';

import * as filters from './utils/filters';

import Antd from 'ant-design-vue';
import App from './App.vue'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import DashboardLayout from './layouts/Dashboard.vue'
import DefaultLayout from './layouts/Default.vue'
import Vue from 'vue'
import mavonEditor from "mavon-editor";
import router from './router'

Vue.use( CKEditor );

// import './plugins/click-away'





Vue.use(Antd);
Vue.use(mavonEditor);

Vue.config.productionTip = false
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')